export default __webpack_public_path__ + "fb9cda073a67df86ac118a440af9ade1.png";